import { GRID_OF_8 } from 'presentation/const/layout.const'

export const sizes = {
  ...GRID_OF_8,
  'app-height': 'var(--app-height)',
  'app-width': 'var(--app-width)',
  'layout-height': 'var(--layout-height)',
}
